const BreelyIcon = ({ size, ...props }) => {
    size = size || 23;
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path fill="#2C87F3" d="M0 0H16V16H0z" />
            <path
                d="M4.356 13.209V2.756h3.832c.556 0 1.057.114 1.503.343.45.224.806.548 1.067.97.266.419.398.914.398 1.487 0 .253-.037.51-.113.769a2.19 2.19 0 01-.345.702 1.402 1.402 0 01-.601.455c.325.08.59.224.796.433.206.21.366.456.481.74.115.278.193.564.233.858.045.289.068.557.068.806 0 .553-.138 1.046-.414 1.479a2.985 2.985 0 01-1.112 1.03c-.46.254-.972.38-1.533.38h-4.26zm1.833-1.56h2.24c.3 0 .57-.073.811-.217.24-.145.433-.344.579-.598.145-.253.218-.542.218-.866 0-.278-.073-.542-.218-.791a1.766 1.766 0 00-.579-.605 1.47 1.47 0 00-.812-.231H6.19v3.307zm0-4.846h1.789c.37 0 .686-.115.946-.344.266-.229.399-.533.399-.91 0-.404-.133-.708-.399-.912a1.465 1.465 0 00-.946-.313H6.189v2.479z"
                fill="#fff"
            />
        </svg>
    );
};

export default BreelyIcon;
